import { css, type Theme } from "@emotion/react";

import * as utilities from "@styles/emotion-styles/utilities";

export const listGridSelector = css`
  display: flex;
  align-items: center;
`;
export const button = {
  base: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background-color: transparent;
    height: 2.25rem;
    width: 2.25rem;
    margin: 0.25rem;
  `,
  isDisabled: css`
    cursor: not-allowed;
  `,
};

export const icon = {
  base: (theme: Theme) => css`
    &&& {
      width: 1.75rem;
      height: 1.5rem;
      color: ${theme.system.backgroundMutedActive};
      ${utilities.transition};
      &:hover {
        color: ${theme.primary.backgroundBase};
      }
    }
  `,
  isActive: (theme: Theme) => css`
    &&& {
      color: ${theme.primary.backgroundBase};
    }
  `,
  isDisabled: (theme: Theme) => css`
    &&& {
      color: ${theme.disabled.text};
      &:hover {
        color: ${theme.disabled.text};
      }
    }
  `,
};
